import { Button, Icon } from "@components";
import { FC } from "react";
import bymeE from '@assets/icons/bymeE.svg';
import { useController } from "./useController";
import { ChatErrorMessage, EmptyState, MessageBubble } from "./components";

export const BymeE: FC = () => {

    const {
        isChatVisible, currentMessage,
        messages, isLoadingChat,
        error, messagesEndRef,
        toggleChat, handleRetry, handleClearChat,
        setCurrentMessage, handleSendMessage,
    } = useController();

    return (
        <div
            className="fixed z-50 bottom-[7%] lg:bottom-2 right-0"
        >
            <div className="relative inline-block">
                <img
                    alt="Bym-E"
                    src={bymeE}
                    onClick={toggleChat}
                    width={65}
                    className="cursor-pointer transition-transform 
                    duration-300 ease-in-out hover:scale-110"
                />
            </div>

            {
                isChatVisible && (
                    <div
                        className="fixed
                            bottom-0 right-0
                            w-full h-[90vh] 
                            min-h-[300px] max-h-[90vh] 
                            bg-base-200 
                            shadow-lg flex flex-col 
                            lg:w-[550px] lg:h-[650px] lg:max-h-[650px] 
                            lg:rounded-lg lg:right-1
                            lg:absolute lg:bottom-14"
                    >
                        <div
                            className="p-2 bg-neutral-200 border-b border-base-300 
                                flex justify-between items-center
                                sticky top-0 bg-base-200 lg:rounded-md"
                        >
                            <span className="font-bold">Bym-E Assistant</span>
                            <Button
                                onClick={toggleChat}
                                className="btn btn-sm btn-ghost"
                            >
                                <Icon iconName="X" size={20} />
                            </Button>
                        </div>

                        <div
                            className="flex-1 overflow-y-auto p-4 
                                max-h-[calc(90vh-120px)]"
                        >
                            {
                                error && <ChatErrorMessage
                                    message={error}
                                    onRetry={handleRetry}
                                />
                            }

                            {
                                // messages.length === 0 ? (
                                messages.length === 1 ? (
                                    <EmptyState bymESource={bymeE} />
                                ) : (
                                    messages.slice(1).map((msg, index) => (
                                        <MessageBubble
                                            key={index}
                                            bymESource={bymeE}
                                            message={msg}
                                            onRetry={handleRetry}
                                        />
                                    ))
                                )
                            }

                            {
                                isLoadingChat && (
                                    <div className="flex justify-center items-center p-2">
                                        <span className="loading loading-dots loading-md" />
                                    </div>
                                )
                            }

                            <div ref={messagesEndRef} />
                        </div>

                        <div
                            className="p-4 border-t border-base-300 sticky bottom-0 bg-base-200 w-full"
                        >
                            <div className="flex items-center gap-2 w-full">
                                <input
                                    type="text"
                                    placeholder="Saisir votre requête..."
                                    className="input input-bordered flex-grow focus:outline-none"
                                    value={currentMessage}
                                    onChange={(e) => setCurrentMessage(e.target.value)}
                                    disabled={isLoadingChat}
                                    // disabled
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && currentMessage) {
                                            handleSendMessage();
                                        }
                                    }}
                                />
                                <Button
                                    variant="primary"
                                    className="btn-circle"
                                    disabled={isLoadingChat || !currentMessage}
                                    // disabled
                                    onClick={handleSendMessage}
                                >
                                    <Icon iconName="Send" size={20} />
                                </Button>

                                <Button
                                    variant='secondary'
                                    className="btn-circle"
                                    disabled={isLoadingChat || messages.length <= 1}
                                    // disabled
                                    onClick={handleClearChat}
                                >
                                    <Icon iconName="Trash2" size={20} />
                                </Button>
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    );
};
